<script setup lang="ts">
import imageRu1 from '~/assets/images/interests/gallery/i-1.png';
import imageRu2 from '~/assets/images/interests/gallery/i-2.png';
import imageRu3 from '~/assets/images/interests/gallery/i-3.png';
import imageRu4 from '~/assets/images/interests/gallery/i-4.png';

const getImage = useImage();
const { t } = useI18n();

const IMAGES: {
  src: string;
  class?: string;
  alt: string;
}[] = [
  {
    src: getImage(t('list.0.src', { urlEn: imageRu1, urlRu: imageRu1 }), {
      format: 'webp',
    }),
    alt: t('list.0.alt'),
  },
  {
    src: getImage(t('list.1.src', { urlEn: imageRu2, urlRu: imageRu2 }), {
      format: 'webp',
    }),
    alt: t('list.1.alt'),
  },
  {
    src: getImage(t('list.2.src', { urlEn: imageRu3, urlRu: imageRu3 }), {
      format: 'webp',
    }),
    alt: t('list.2.alt'),
    class: 'hidden sm:block md:hidden xl:block',
  },
  {
    src: getImage(t('list.3.src', { urlEn: imageRu4, urlRu: imageRu4 }), {
      format: 'webp',
    }),
    alt: t('list.3.alt'),
  },
];
</script>

<template>
  <section class="p-section pt-20 pb-16 bg-surface-700">
    <h2 class="text-3xl md:text-5xl text-800 text-center mt-0 mb-8">
      {{ t('title') }}
    </h2>
    <div
      class="lg:container grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 xl:grid-cols-4 gap-4"
    >
      <div
        data-show-on-visible
        class="bg-surface-800 shadow-2 rounded-lg p-3"
        v-for="image in IMAGES"
        :key="image.src"
        :class="image.class"
        style="border-radius: 6px"
      >
        <Image
          :src="image.src"
          :alt="image.alt"
          class="w-full !block aspect-screenshot"
          preview
          :preview-button-props="{ 'aria-label': t('zoom_image_button') }"
          :pt="{ image: { class: 'w-full object-cover', loading: 'lazy' } }"
        />
      </div>
    </div>
  </section>
</template>

<i18n>
en:
  title: What the game looks like
  zoom_image_button: Enlarge image
  list:
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''

ru:
  title: Как выглядит игра
  zoom_image_button: Увеличить изображение
  list:
    - src: '{urlRu}'
      alt: ''
    - src: '{urlRu}'
      alt: ''
    - src: '{urlRu}'
      alt: ''
    - src: '{urlRu}'
      alt: ''

de:
  title: Wie das Spiel aussieht
  zoom_image_button: Bild vergrößern
  list:
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''

es:
  title: Cómo se ve el juego
  zoom_image_button: Ampliar imagen
  list:
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''

fr:
  title: Vnat te juego lux como
  zoom_image_button: Ampliar imagen
  list:
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
    - src: '{urlEn}'
      alt: ''
</i18n>
